import { useCallback, useContext } from "react";
import { useQuery } from "react-query";

import { UseQueryProps } from "../../interfaces";
import { apiServiceContext } from "../../api-service-context";
import { QueryKeys } from "../query-keys";

export const useBookingOfUser = <TData = any, TError = any>(
  queryOptions: UseQueryProps<TData, TError> = {}
) => {
  const { bookingApiService } = useContext(apiServiceContext);
  const queryFn = useCallback(
    () =>
      bookingApiService.createCancellableRequest((cancelToken) =>
        bookingApiService.getBookingOfUser(cancelToken)
      ),
    [bookingApiService]
  );

  return useQuery(QueryKeys.bookingOfUser(), queryFn, queryOptions);
};
